import React from 'react';
import '../styles/components.css';

const Table = ({ columns, data, onRowClick, onEdit, onDelete, actions }) => {
  const hasActions = onEdit || onDelete || actions;

  // Separate data columns from an inline "acciones" column
  const dataCols = columns.filter(c => c.key !== 'acciones');
  const accionesCol = columns.find(c => c.key === 'acciones');

  const renderActions = (row) => (
    <div className="table-card-actions">
      {accionesCol && accionesCol.render && accionesCol.render(undefined, row)}
      {actions && actions.map((action, i) => (
        <button
          key={i}
          className={`btn btn--sm ${action.variant ? `btn--${action.variant}` : 'btn--secondary'}`}
          onClick={(e) => { e.stopPropagation(); action.onClick(row); }}
          title={action.title || ''}
        >
          {action.label}
        </button>
      ))}
      {onEdit && (
        <button className="btn btn--sm btn--primary" onClick={(e) => { e.stopPropagation(); onEdit(row); }}>
          Editar
        </button>
      )}
      {onDelete && (
        <button className="btn btn--sm btn--danger" onClick={(e) => { e.stopPropagation(); onDelete(row); }}>
          Eliminar
        </button>
      )}
    </div>
  );

  return (
    <>
      {/* Desktop: tabla */}
      <div className="table-container table-desktop">
        <table className="table">
          <thead>
            <tr>
              {columns.map((col, i) => (
                <th key={i} className={col.align ? `text-${col.align}` : ''}>
                  {col.label || col.header}
                </th>
              ))}
              {hasActions && !accionesCol && <th>Acciones</th>}
            </tr>
          </thead>
          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan={columns.length + (hasActions && !accionesCol ? 1 : 0)} className="text-center">
                  No hay datos disponibles
                </td>
              </tr>
            ) : (
              data.map((row, rowIndex) => (
                <tr
                  key={rowIndex}
                  onClick={() => onRowClick && onRowClick(row)}
                  className={onRowClick ? 'table-row-clickable' : ''}
                >
                  {columns.map((col, colIndex) => {
                    const value = row[col.key || col.field];
                    return (
                      <td key={colIndex} className={col.align ? `text-${col.align}` : ''}>
                        {col.render ? col.render(value, row) : value}
                      </td>
                    );
                  })}
                  {hasActions && !accionesCol && (
                    <td>
                      <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                        {actions && actions.map((action, i) => (
                          <button
                            key={i}
                            className={`btn btn--sm ${action.variant ? `btn--${action.variant}` : 'btn--secondary'}`}
                            onClick={(e) => { e.stopPropagation(); action.onClick(row); }}
                            title={action.title || ''}
                          >
                            {action.label}
                          </button>
                        ))}
                        {onEdit && (
                          <button className="btn btn--sm btn--primary" onClick={(e) => { e.stopPropagation(); onEdit(row); }}>
                            Editar
                          </button>
                        )}
                        {onDelete && (
                          <button className="btn btn--sm btn--danger" onClick={(e) => { e.stopPropagation(); onDelete(row); }}>
                            Eliminar
                          </button>
                        )}
                      </div>
                    </td>
                  )}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Mobile: cards */}
      <div className="table-mobile">
        {data.length === 0 ? (
          <p className="empty-message">No hay datos disponibles</p>
        ) : (
          data.map((row, rowIndex) => (
            <div
              key={rowIndex}
              className={`table-card${onRowClick ? ' table-card--clickable' : ''}`}
              onClick={() => onRowClick && onRowClick(row)}
            >
              {dataCols.map((col, colIndex) => {
                const value = row[col.key || col.field];
                const rendered = col.render ? col.render(value, row) : value;
                if (rendered === null || rendered === undefined) return null;
                return (
                  <div key={colIndex} className="table-card-row">
                    <span className="table-card-label">{col.label || col.header}</span>
                    <span className="table-card-value">{rendered}</span>
                  </div>
                );
              })}
              {(accionesCol || hasActions) && renderActions(row)}
            </div>
          ))
        )}
      </div>
    </>
  );
};

export default React.memo(Table);
